const closeButtonLabel = "Schließen";
const deLU = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  deLU as default
};
